<template>
  <div>
    <my-header/>

    <div class="page">
      <b-breadcrumb>
        <b-breadcrumb-item :to="{name:'rushes'}">Ражи</b-breadcrumb-item>
        <b-breadcrumb-item :to="{name:'rush_info'}">Раж {{rushId}}</b-breadcrumb-item>
      </b-breadcrumb>

      <h2>Игрок {{playerId}} (участник ража)</h2>

      <div class="section-container">
        <side-nav
          :menuItems="menuItems"
          class="side-nav"
        />

        <div class="content-box">
          <router-view></router-view>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'RushPlayer',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    rushPlayerId: {
      type: Object,
      required: true
    }
  },

  computed: {
    /** @returns {number} */
    rushId() {
      return this.rushPlayerId.rushId;
    },

    /** @returns {number} */
    playerId() {
      return this.rushPlayerId.playerId;
    },

    menuItems() {
      return [
        {
          title: 'Информация',
          route: {name: 'rush_player_info', params: {rushPlayerId: this.rushPlayerId}},
        },
        {
          title: 'Заезды',
          route: {name: 'rush_player_races', params: {rushPlayerId: this.rushPlayerId}},
        },
      ];
    },
  },

};
</script>

<style scoped>
.page {
  margin-left: 1rem;
  max-width: 600px;
}

.section-container {
  display: flex;
  align-items: flex-start;
}

.side-nav {
  margin-right: 2rem;
  background-color: rgb(242, 247, 251);
}

.content-box {
  width: 600px;
}
</style>
